import React, { useMemo, useEffect } from "react";
import { LoginViewSelector } from "./loginViewSelector";
import "./styles.scss";
import { TeacherAndParentLogin } from "./teacherAndParentLogin";
import { HashRouter, Redirect, Route, Router, Switch } from "react-router-dom";
import { StudentLogin } from "./studentLogin";
import { StudentUsernameLogin } from "./studentLogin/usernameLogin";
import { pushEventToGTM } from '../commonHelpers/pushEventToGTM';
import { StudentKlassCodeLogin } from "./studentLogin/KlassCodeLogin";
import { StudentQRCodeLogin } from "./studentLogin/QRcodeLogin";
import { history } from "./history";
import { CommonLogin } from "./commonLogin";
import { checkPlayDomainHealthAPI } from "./api";


const StudentRoutes = ({showBackButton = true}) => ( 
  <>
    <Route path="/student" component={() => <StudentLogin showBackButton={showBackButton}/>}/>
    <Route path="/student-username" component={StudentUsernameLogin}/>
    <Route path="/student-klasscode" component={StudentKlassCodeLogin}/>
    <Route path="/student-qrcode" component={StudentQRCodeLogin}/>
  </>
);

const AuthSigninView = () => {

  useEffect(() => {
    sessionStorage?.setItem('manage_classes_path', 'Login');
    sessionStorage?.removeItem('add_studentList');
    trackAnalyticsEvent('Account Type Screen Shown', {'Intent for': 'login', 'Screen type': 'page', 'From Page': 'signin'}, true);
    pushEventToGTM('Account Type Screen Shown', {'Intent for': 'login', 'Screen type': 'page', 'From Page': 'signin'});
    checkPlayDomainHealthAPI();
    $('#header-mobile-content').css('position', "absolute");
    return () => {
      $('#header-mobile-content').css('position', "");      
    };

  }, [])
  
  return (
    <div
      className="auth-signin-view"
      ref={(ref) => {
        if(ref){
          const elementDetails = ref?.getBoundingClientRect();
          if(elementDetails){
            ref.style.height = `calc(100vh - ${elementDetails.top}px)`;
          }
        }
      }}
    >
      <Router history={history}>
        <Route exact path="/signin" component={() => (
          <HashRouter>
            <Switch>
              <Route exact path="/" component={LoginViewSelector}/>
              <Route path="/teacher" component={() => <TeacherAndParentLogin isTeacher={true} />}/>
              <Route path="/parent" component={() => <TeacherAndParentLogin isParent={true} />}/>
              <StudentRoutes />
              <Route path="*" render={() => <Redirect to={"/"}/>} />
            </Switch>
          </HashRouter>
        )}/>
        <Route path="/student" component={() => (
          <HashRouter>
            <Switch>
              <Route exact path="/" component={() => <StudentLogin showBackButton={false}/>}/>
              <StudentRoutes showBackButton={false}/>
              <Route path="*" render={() => <Redirect to={"/"}/>} />
            </Switch>
          </HashRouter>
        )}/>
        <Route path="/teachers/signin" component={() => <CommonLogin isParent={false}/>}/>
        <Route path="/parents/signin" component={() => <CommonLogin isParent={true}/>}/>
      </Router>
      {/* {componentToRender} */}
    </div>
  );
};

export default AuthSigninView;
